export default __webpack_public_path__ + "static/media/doc.05d3962c.svg";